import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PictogramImage } from "@/components/PictogramImage";

export const ReadonlyPictograms = () => {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = async () => {
    try {
      const [pictos, cats] = await Promise.all([api.get("/pictograms"), api.get("/pictogram-categories")]);
      setItems(pictos.data); setCategories(cats.data); setError("");
    } catch { setError("Impossibile caricare i pittogrammi."); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const visible = items.filter(p => !p.is_default_derivative);
  const visibleCategories = categories.filter(cat => !cat.is_default_derivative);
  const groups = visibleCategories
    .map(cat => ({ ...cat, items: visible.filter(p => p.category_id === cat.id) }));
  const ungrouped = visible.filter(p => !visibleCategories.some(c => c.id === p.category_id));
  if (ungrouped.length) groups.push({ id: "other", name: "Senza categoria", items: ungrouped });
  return <div data-testid="readonly-pictograms">
    {loading && <p className="text-sm text-[#707070]" data-testid="readonly-pictograms-loading">Caricamento...</p>}
    {error && <div role="alert" className="text-sm text-[#B91C1C]" data-testid="readonly-pictograms-error">{error}
      <button type="button" onClick={load} className="underline ml-2" data-testid="readonly-pictograms-retry">Riprova</button></div>}
    {!loading && !error && !visible.length && <p className="text-sm text-[#707070]" data-testid="readonly-pictograms-empty">Nessun pittogramma disponibile.</p>}
    {!loading && !error && groups.filter(g => g.items.length).map(group => <section key={group.id} className="mb-8" data-testid={`readonly-pictogram-group-${group.id}`}>
      <h3 className="font-serif text-xl mb-4" data-testid={`readonly-pictogram-title-${group.id}`}>{group.name}</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {group.items.map(p => <div key={p.id} className="border border-[#D4D4D4] p-4 flex flex-col items-center gap-2 min-w-0" data-testid={`readonly-pictogram-${p.id}`}>
          <PictogramImage pictogram={p} className="w-12 h-12" testId={`readonly-pictogram-image-${p.id}`} />
          <span className="text-sm text-center break-words" data-testid={`readonly-pictogram-name-${p.id}`}>{p.name}</span>
          <span className="text-[10px] text-[#707070]" data-testid={`readonly-pictogram-origin-${p.id}`}>{p.is_default ? "Default" : "Personale"}</span>
        </div>)}
      </div>
    </section>)}
  </div>;
};